import React from 'react';
import { TrendingUp, TrendingDown, AlertTriangle, DollarSign, Clock, CheckCircle } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
export function Dashboard() {
  const kpis = [{
    title: 'Soumissions en cours',
    value: '12',
    change: '+3',
    trend: 'up',
    icon: <CheckCircle size={24} data-id="element-288" />,
    color: 'text-red-600 bg-red-50'
  }, {
    title: 'Chantiers actifs',
    value: '8',
    change: '+1',
    trend: 'up',
    icon: <TrendingUp size={24} data-id="element-289" />,
    color: 'text-green-600 bg-green-50'
  }, {
    title: 'Chantiers à risque',
    value: '2',
    change: '-1',
    trend: 'down',
    icon: <AlertTriangle size={24} data-id="element-290" />,
    color: 'text-orange-600 bg-orange-50'
  }, {
    title: 'Facturation du mois',
    value: '1.2M$',
    change: '+15%',
    trend: 'up',
    icon: <DollarSign size={24} data-id="element-291" />,
    color: 'text-purple-600 bg-purple-50'
  }];
  const riskSites = [{
    id: 'CH-022',
    name: 'Réfection Rue King',
    delay: '12 jours',
    budget: '-8%'
  }, {
    id: 'CH-014',
    name: 'Égout Laval',
    delay: '5 jours',
    budget: '-3%'
  }];
  const chartData = [{
    month: 'Jan',
    soumises: 8,
    gagnees: 3,
    enCours: 5
  }, {
    month: 'Fév',
    soumises: 12,
    gagnees: 5,
    enCours: 7
  }, {
    month: 'Mar',
    soumises: 10,
    gagnees: 4,
    enCours: 6
  }, {
    month: 'Avr',
    soumises: 15,
    gagnees: 6,
    enCours: 9
  }, {
    month: 'Mai',
    soumises: 18,
    gagnees: 8,
    enCours: 10
  }, {
    month: 'Juin',
    soumises: 14,
    gagnees: 6,
    enCours: 8
  }];
  return <div className="space-y-6" data-id="element-292">
      <div className="flex items-center justify-between" data-id="element-293">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-294">Portefeuille</h1>
        <div className="flex items-center space-x-2" data-id="element-295">
          <select className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" data-id="element-296">
            <option data-id="element-297">30 derniers jours</option>
            <option data-id="element-298">90 derniers jours</option>
            <option data-id="element-299">Cette année</option>
          </select>
        </div>
      </div>
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-300">
        {kpis.map((kpi, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-301">
            <div className="flex items-center justify-between mb-4" data-id="element-302">
              <div className={`p-3 rounded-lg ${kpi.color}`} data-id="element-303">{kpi.icon}</div>
              <span className={`text-sm font-medium ${kpi.trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-304">
                {kpi.change}
              </span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-305">
              {kpi.value}
            </h3>
            <p className="text-sm text-gray-600" data-id="element-306">{kpi.title}</p>
          </div>)}
      </div>
      {/* Risk Sites */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-307">
        <div className="flex items-center justify-between mb-4" data-id="element-308">
          <h2 className="text-xl font-semibold text-gray-900" data-id="element-309">
            Chantiers à risque
          </h2>
          <button className="text-blue-600 hover:text-blue-700 font-medium text-sm" data-id="element-310">
            Voir tous
          </button>
        </div>
        <div className="space-y-3" data-id="element-311">
          {riskSites.map(site => <div key={site.id} className="flex items-center justify-between p-4 bg-red-50 border border-red-200 rounded-lg" data-id="element-312">
              <div className="flex items-center space-x-4" data-id="element-313">
                <AlertTriangle className="text-red-600" size={24} data-id="element-314" />
                <div data-id="element-315">
                  <h3 className="font-semibold text-gray-900" data-id="element-316">{site.name}</h3>
                  <p className="text-sm text-gray-600" data-id="element-317">{site.id}</p>
                </div>
              </div>
              <div className="flex items-center space-x-6 text-sm" data-id="element-318">
                <div className="text-right" data-id="element-319">
                  <p className="text-gray-600" data-id="element-320">Retard</p>
                  <p className="font-semibold text-red-600" data-id="element-321">{site.delay}</p>
                </div>
                <div className="text-right" data-id="element-322">
                  <p className="text-gray-600" data-id="element-323">Budget</p>
                  <p className="font-semibold text-red-600" data-id="element-324">{site.budget}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      {/* Submissions Trend Chart */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-325">
        <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-326">
          Tendance des soumissions
        </h2>
        <ResponsiveContainer width="100%" height={300} data-id="element-327">
          <AreaChart data={chartData} margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0
        }} data-id="element-328">
            <defs data-id="element-329">
              <linearGradient id="colorSoumises" x1="0" y1="0" x2="0" y2="1" data-id="element-330">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} data-id="element-331" />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} data-id="element-332" />
              </linearGradient>
              <linearGradient id="colorGagnees" x1="0" y1="0" x2="0" y2="1" data-id="element-333">
                <stop offset="5%" stopColor="#10b981" stopOpacity={0.8} data-id="element-334" />
                <stop offset="95%" stopColor="#10b981" stopOpacity={0} data-id="element-335" />
              </linearGradient>
              <linearGradient id="colorEnCours" x1="0" y1="0" x2="0" y2="1" data-id="element-336">
                <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.8} data-id="element-337" />
                <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} data-id="element-338" />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" data-id="element-339" />
            <XAxis dataKey="month" stroke="#6b7280" style={{
            fontSize: '12px'
          }} data-id="element-340" />
            <YAxis stroke="#6b7280" style={{
            fontSize: '12px'
          }} data-id="element-341" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '8px 12px'
          }} data-id="element-342" />
            <Legend wrapperStyle={{
            paddingTop: '20px'
          }} iconType="circle" data-id="element-343" />
            <Area type="monotone" dataKey="soumises" stroke="#3b82f6" fillOpacity={1} fill="url(#colorSoumises)" name="Soumises" strokeWidth={2} data-id="element-344" />
            <Area type="monotone" dataKey="gagnees" stroke="#10b981" fillOpacity={1} fill="url(#colorGagnees)" name="Gagnées" strokeWidth={2} data-id="element-345" />
            <Area type="monotone" dataKey="enCours" stroke="#f59e0b" fillOpacity={1} fill="url(#colorEnCours)" name="En cours" strokeWidth={2} data-id="element-346" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>;
}